import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PageHeader, DataCard, StatusPill } from "@/components/admin/AdminPrimitives";
import { Skeleton } from "@/components/ui/skeleton";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/produtos")({
  head: () => ({ meta: [{ title: "Produtos — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: ProdutosAdmin,
});

function fmtBRL(cents: number) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);
}

function ProdutosAdmin() {
  const list = useQuery({
    queryKey: ["admin.produtos"],
    queryFn: async () => {
      const { data } = await supabase.from("products").select("*").order("created_at", { ascending: false });
      return data ?? [];
    },
  });
  return (
    <div>
      <PageHeader
        title="Produtos"
        description="Catálogo de ofertas, planos e checkouts."
        actions={
          <button className="inline-flex items-center gap-1.5 rounded-lg bg-[var(--navy)] px-3 py-2 text-sm font-semibold text-white hover:opacity-90">
            <Plus size={14} /> Novo produto
          </button>
        }
      />
      {list.isLoading ? (
        <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-40 rounded-2xl" />)}
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {(list.data ?? []).map((p: any) => (
            <DataCard key={p.id}>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <StatusPill tone={p.active ? "green" : "gray"}>{p.active ? "Ativo" : "Inativo"}</StatusPill>
                  <span className="font-mono text-[10px] text-[var(--gray-ink)]">/{p.slug}</span>
                </div>
                <h3 className="mt-3 font-display text-lg font-extrabold text-[var(--navy)]">{p.name}</h3>
                <p className="mt-1 line-clamp-2 text-sm text-[var(--gray-ink)]">{p.description ?? "Sem descrição."}</p>
                <p className="mt-4 font-display text-2xl font-extrabold text-[var(--green)]">{fmtBRL(p.price_cents)}</p>
              </div>
            </DataCard>
          ))}
          {(list.data ?? []).length === 0 && (
            <p className="col-span-full py-16 text-center text-sm text-[var(--gray-ink)]">Nenhum produto cadastrado.</p>
          )}
        </div>
      )}
    </div>
  );
}
